import { styled } from "styled-components";

interface Props {
  title: string;
  text?: string;
}

export const EmptyState: React.FC<Props> = ({ title, text }) => {
  return (
    <Wrapper>
      <h3 className="h4">{title}</h3>
      {text && <p>{text}</p>}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  text-align: center;
  width: 100%;
  border: 1px solid var(--swatch3);
  padding: ${(props) => props.theme.spacing.m};
  box-sizing: border-box;
`;
